import { Editor, Transforms, Node } from 'slate';
import { firstNonWhitespaceIndex } from '../../utils';
const insertBreakAndKeepIndent = (e, editor, focusPath, forceIndents) => {
    const focusedTextNode = Node.get(editor, focusPath);
    const indents = forceIndents != null
        ? forceIndents
        : firstNonWhitespaceIndex(focusedTextNode.text);
    if (indents <= 0) {
        // Do nothing
        return;
    }
    e.preventDefault();
    Editor.withoutNormalizing(editor, () => {
        Editor.insertBreak(editor);
        Editor.insertText(editor, ' '.repeat(indents));
    });
};
const onEnterDown = (e, editor) => {
    var _a;
    const focus = (_a = editor.selection) === null || _a === void 0 ? void 0 : _a.focus;
    if (focus == null) {
        return;
    }
    const focusIndex = focus.path[0];
    const focusedTopLevelElement = editor.children[focusIndex];
    const parentMdastNode = focusedTopLevelElement.parentMdastNode;
    if (parentMdastNode && parentMdastNode.type === 'listItem') {
        if (parentMdastNode.children.length === 0) {
            // If there is no body
            e.preventDefault();
            Editor.withoutNormalizing(editor, () => {
                editor.insertBreak();
                Transforms.delete(editor, {
                    at: [focusIndex, 0, 0],
                    distance: 1,
                    unit: 'line',
                    reverse: true,
                });
            });
            return;
        }
        const mdastPath = focusedTopLevelElement.flattenedMdastPath;
        if (mdastPath == null) {
            return;
        }
        const focusIdxInListItem = mdastPath[mdastPath.length - 1];
        const markerContainerTopLevelElement = editor.children[focusIndex - focusIdxInListItem];
        const markerContainerLine = markerContainerTopLevelElement.children[0];
        const markerContainerLineText = markerContainerLine.children[0].text;
        const markerStartOffset = firstNonWhitespaceIndex(markerContainerLineText);
        if (markerStartOffset < 0) {
            return;
        }
        const markerEndOffset = parentMdastNode.checked == null
            ? markerStartOffset + ' '.length
            : markerStartOffset + ' [ ] '.length;
        const selfMdast = focusedTopLevelElement.mdastNode;
        if (selfMdast == null) {
            return;
        }
        const leafPosition = selfMdast.position;
        if (leafPosition == null) {
            return;
        }
        // NOTE: mdast's column is 1-indexed and slate's offset is 0-indexed.
        if (focus.path[1] === 0 && focus.offset < markerEndOffset) {
            return;
        }
        const bodyStartColumn = leafPosition.start.column;
        if (selfMdast.type === 'code') {
            const focusLineIndex = focus.path[1];
            if (focusLineIndex === 0) {
                // If the focus is on the first line
                let isOutsideEnclosedCodeBlock = false;
                if (leafPosition.start.line === leafPosition.end.line) {
                    const firstLine = focusedTopLevelElement.children[0];
                    const firstLineText = firstLine.children[0].text;
                    const codeBlockText = firstLineText.slice(leafPosition.start.column - 1, leafPosition.end.column - 1);
                    isOutsideEnclosedCodeBlock = /[^`]/.test(codeBlockText);
                }
                if (!isOutsideEnclosedCodeBlock) {
                    const indents = bodyStartColumn - 1;
                    insertBreakAndKeepIndent(e, editor, focus.path, indents);
                    return;
                }
            }
            else if (focusLineIndex ===
                focusedTopLevelElement.children.length - 1) {
                // If the focus is on the last line
                const lastLine = focusedTopLevelElement.children[focusedTopLevelElement.children.length - 1];
                const lastLineText = lastLine.children[0].text;
                const encloser = lastLineText.slice(leafPosition.end.column - 1 - 3, leafPosition.end.column - 1);
                const isOutsideEnclosedCodeBlock = encloser === '```';
                if (!isOutsideEnclosedCodeBlock) {
                    insertBreakAndKeepIndent(e, editor, focus.path);
                    return;
                }
            }
            else {
                // If the focus is in the middle of the code block
                insertBreakAndKeepIndent(e, editor, focus.path);
                return;
            }
        }
        const markerChar = markerContainerLineText.slice(markerStartOffset, markerStartOffset + 1);
        const marker = parentMdastNode.checked == null ? markerChar + ' ' : markerChar + ' [ ] ';
        e.preventDefault();
        Editor.withoutNormalizing(editor, () => {
            editor.insertBreak();
            Editor.insertText(editor, ' '.repeat(markerStartOffset) + marker);
        });
        return;
    }
    insertBreakAndKeepIndent(e, editor, focus.path);
};
export default onEnterDown;
//# sourceMappingURL=onEnterDown.js.map